export default __webpack_public_path__ + "static/media/instagram_logo.f76ad004.svg";